import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

// Components 

import Box from '@mui/material/Box';
import Button from '../../../general/inputs/Button';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { setIsGroupInfoPopupOpened, setSelectedGroup, setSelectedGroupBillingInfo } from '../../../../redux/features/hacker/users/groupsAccess';
import GroupAccessList from './GroupAccessList';
import GroupSettings from './GroupSettings';
import GroupLogs from './GroupLogs';
import GroupUsage from './GroupUsage';
import CancelButton from '../../../general/inputs/CancelButton';
import Popup from '../../../general/popups/items/Popup';
import GroupBillingInfo from './GroupBillingInfo';


interface Props { 

}; 

const GroupInfo: React.FC<Props> = ({ }) => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const { consultationId } = useParams(); 

    const colors = useAppSelector(state => state.theme.colors); 

    // -- 

    const handleQuit = () => { 

        dispatch(setIsGroupInfoPopupOpened(false)); 

        dispatch(setSelectedGroup(null)); 
        dispatch(setSelectedGroupBillingInfo(null)); 

    }; 
    
    // -- 

    return (

        <Popup
            popupExtraStyle={{ 
                width: '80vw',
                height: '90vh',
                overflow: 'scroll', 
                overflowX: 'hidden', 
                padding: 1, 
            }}
        >

            <Box
                sx={{ 
                    display: 'flex', 
                    flexDirection: 'row',
                    alignItems: 'center', 
                    justifyContent: 'space-evenly', 
                    textAlign: 'center', 
                    width: '100%', 
                    maxHeight: 400, 
                    marginTop: 2, 
                }}
            >

                <GroupAccessList />

                <GroupSettings />

            </Box>

            <GroupUsage />

            <GroupBillingInfo />

            <GroupLogs />

            <CancelButton handler={handleQuit} />

        </Popup>

  );

};

export default GroupInfo;